module.exports = __webpack_public_path__ + "img/delivery-warehouse.efff3d51.svg";